import { render, staticRenderFns } from "./EditShotModal.vue?vue&type=template&id=8b2c4e12&scoped=true&"
import script from "./EditShotModal.vue?vue&type=script&lang=js&"
export * from "./EditShotModal.vue?vue&type=script&lang=js&"
import style0 from "./EditShotModal.vue?vue&type=style&index=0&id=8b2c4e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2c4e12",
  null
  
)

export default component.exports